import { useMemo } from 'react';
import { VStack } from '@astryxdesign/core/Stack';
import { Heading, Text } from '@astryxdesign/core/Text';
import { List, ListItem } from '@astryxdesign/core/List';
import { Button } from '@astryxdesign/core/Button';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { useTenant } from '@/app/tenant-context';
import { duration, money } from '@/lib/format';
import { Reveal } from '@/components/Reveal';
import { useShell } from './ClientShell';

export function ServicesPage() {
  const { tenant } = useTenant();
  const { openBooking } = useShell();
  const groups = useMemo(() => {
    const m = new Map<string, typeof tenant.services>();
    for (const s of tenant.services) {
      const k = s.category || 'Услуги';
      m.set(k, [...(m.get(k) ?? []), s]);
    }
    return [...m.entries()];
  }, [tenant.services]);

  return (
    <VStack gap={8} paddingInline={4} paddingBlockStart={8} className="safe-top">
      <VStack gap={2}>
        <Heading level={1}>Услуги и цены</Heading>
        <Text color="secondary">Время рассчитано с подготовкой бокса. Окончательная цена — после осмотра, если указано «от».</Text>
      </VStack>
      {groups.length === 0 && <EmptyState title="Список услуг скоро появится" description="Позвоните в студию, чтобы записаться." />}
      {groups.map(([category, services]) => (
        <Reveal key={category} label={category}>
          <VStack gap={2}>
            <Heading level={2}>{category}</Heading>
            <List density="spacious" hasDividers>
              {services.map((s) => (
                <ListItem
                  key={s.id}
                  label={s.name}
                  description={
                    <VStack gap={1}>
                      {s.description && <Text type="supporting">{s.description}</Text>}
                      <Text type="supporting">
                        {duration(s.duration_minutes)} · {money(s.price_cents, tenant.currency, s.price_is_from)}
                      </Text>
                    </VStack>
                  }
                  endContent={<Button label="Записаться" size="sm" variant="primary" onClick={() => openBooking(s.id)} />}
                />
              ))}
            </List>
          </VStack>
        </Reveal>
      ))}
    </VStack>
  );
}
